const translations = {
  // ===== Header =====
  'nav.destinations': {
    ru: 'НАПРАВЛЕНИЯ', en: 'DESTINATIONS', lv: 'GALAMĒRĶI', lt: 'KRYPTYS', pl: 'KIERUNKI',
  },
  'nav.buses': {
    ru: 'АВТОБУСЫ', en: 'BUSES', lv: 'AUTOBUSI', lt: 'AUTOBUSAI', pl: 'AUTOBUSY',
  },
  'nav.info': {
    ru: 'ИНФОРМАЦИЯ', en: 'INFORMATION', lv: 'INFORMĀCIJA', lt: 'INFORMACIJA', pl: 'INFORMACJA',
  },
  'nav.superior': {
    ru: 'LUX EXPRESS SUPERIOR', en: 'LUX EXPRESS SUPERIOR', lv: 'LUX EXPRESS SUPERIOR', lt: 'LUX EXPRESS SUPERIOR', pl: 'LUX EXPRESS SUPERIOR',
  },
  'nav.routes': {
    ru: 'МАРШРУТЫ', en: 'ROUTES', lv: 'MARŠRUTI', lt: 'MARŠRUTAI', pl: 'TRASY',
  },
  'nav.myBookings': {
    ru: 'МОИ БРОНИРОВАНИЯ', en: 'MY BOOKINGS', lv: 'MANI BRAUCIENI', lt: 'MANO REZERVACIJOS', pl: 'MOJE REZERWACJE',
  },
  'nav.passengers': {
    ru: 'ПАССАЖИРАМ', en: 'PASSENGERS', lv: 'PASAŽIERIEM', lt: 'KELEIVIAMS', pl: 'PASAŻEROM',
  },
  'nav.about': {
    ru: 'О НАС', en: 'ABOUT US', lv: 'PAR MUMS', lt: 'APIE MUS', pl: 'O NAS',
  },
  'nav.login': {
    ru: 'Авторизация', en: 'Log in', lv: 'Pieteikties', lt: 'Prisijungti', pl: 'Logowanie',
  },

  // ===== Search Form =====
  'search.from': {
    ru: 'Откуда', en: 'From', lv: 'No kurienes', lt: 'Iš kur', pl: 'Skąd',
  },
  'search.to': {
    ru: 'Куда', en: 'To', lv: 'Uz kurieni', lt: 'Į kur', pl: 'Dokąd',
  },
  'search.selectCity': {
    ru: 'Выберите город', en: 'Select city', lv: 'Izvēlieties pilsētu', lt: 'Pasirinkite miestą', pl: 'Wybierz miasto',
  },
  'search.enterCity': {
    ru: 'Ввести пункт', en: 'Enter city', lv: 'Ievadiet pilsētu', lt: 'Įveskite miestą', pl: 'Wpisz miasto',
  },
  'search.departureDate': {
    ru: 'Отправление туда', en: 'Departure', lv: 'Izbraukšana', lt: 'Išvykimas', pl: 'Wyjazd',
  },
  'search.returnDate': {
    ru: 'Отправление обратно', en: 'Return', lv: 'Atpakaļceļš', lt: 'Grįžimas', pl: 'Powrót',
  },
  'search.returnDateShort': {
    ru: 'Обратно', en: 'Return', lv: 'Atpakaļ', lt: 'Atgal', pl: 'Powrót',
  },
  'search.departureDateShort': {
    ru: 'Туда', en: 'Depart', lv: 'Turp', lt: 'Ten', pl: 'Tam',
  },
  'search.passengers': {
    ru: 'Пассажиры', en: 'Passengers', lv: 'Pasažieri', lt: 'Keleiviai', pl: 'Pasażerowie',
  },
  'search.adult': {
    ru: 'Взрослый', en: 'Adult', lv: 'Pieaugušais', lt: 'Suaugęs', pl: 'Dorosły',
  },
  'search.adults': {
    ru: 'Взрослые', en: 'Adults', lv: 'Pieaugušie', lt: 'Suaugusieji', pl: 'Dorośli',
  },
  'search.adultsAge': {
    ru: 'от 16 лет', en: 'from 16 years', lv: 'no 16 gadiem', lt: 'nuo 16 metų', pl: 'od 16 lat',
  },
  'search.searchBtn': {
    ru: 'Поиск', en: 'Search', lv: 'Meklēt', lt: 'Ieškoti', pl: 'Szukaj',
  },
  'search.cancel': {
    ru: 'Отмена', en: 'Cancel', lv: 'Atcelt', lt: 'Atšaukti', pl: 'Anuluj',
  },
  'search.searchCity': {
    ru: 'Поиск города...', en: 'Search city...', lv: 'Meklēt pilsētu...', lt: 'Ieškoti miesto...', pl: 'Szukaj miasta...',
  },
  'search.selectDate': {
    ru: 'Выбрать дату', en: 'Select date', lv: 'Izvēlēties datumu', lt: 'Pasirinkite datą', pl: 'Wybierz datę',
  },

  // ===== Hero =====
  'hero.title': {
    ru: 'Lux Express', en: 'Lux Express', lv: 'Lux Express', lt: 'Lux Express', pl: 'Lux Express',
  },
  'hero.subtitle': {
    ru: 'Комфорт, созданный для путешествий!',
    en: 'Comfort designed for travel!',
    lv: 'Komforts, radīts ceļojumiem!',
    lt: 'Komfortas, sukurtas kelionėms!',
    pl: 'Komfort stworzony do podróży!',
  },

  // ===== Popular Routes =====
  'routes.popular': {
    ru: 'Самые популярные направления', en: 'Most popular destinations', lv: 'Populārākie maršruti', lt: 'Populiariausi maršrutai', pl: 'Najpopularniejsze kierunki',
  },

  // ===== Destinations =====
  'destinations.title': {
    ru: 'Самые популярные направления', en: 'Most popular destinations', lv: 'Populārākie galamērķi', lt: 'Populiariausios kryptys', pl: 'Najpopularniejsze kierunki',
  },

  // ===== Features =====
  'features.title': {
    ru: 'Почему пассажиры предпочитают Lux Express',
    en: 'Why passengers prefer Lux Express',
    lv: 'Kāpēc pasažieri dod priekšroku Lux Express',
    lt: 'Kodėl keleiviai renkasi Lux Express',
    pl: 'Dlaczego pasażerowie wybierają Lux Express',
  },
  'features.time.title': {
    ru: 'Время с пользой', en: 'Time well spent', lv: 'Laiks ar labumu', lt: 'Laikas su nauda', pl: 'Czas z pożytkiem',
  },
  'features.time.desc': {
    ru: 'Мы предлагаем нашим пассажирам провести время с пользой и заняться теми делами, на которые обычно не хватает свободных минут.',
    en: 'We offer our passengers to spend their time productively and take care of things they usually don\'t have time for.',
    lv: 'Mēs piedāvājam mūsu pasažieriem pavadīt laiku lietderīgi un paveikt lietas, kurām parasti nepietiek brīvo minūšu.',
    lt: 'Siūlome keleiviams praleisti laiką naudingai ir užsiimti dalykais, kuriems paprastai neužtenka laisvų minučių.',
    pl: 'Oferujemy naszym pasażerom spędzenie czasu z pożytkiem i zajęcie się sprawami, na które zwykle brakuje czasu.',
  },
  'features.comfort.title': {
    ru: 'Комфорт', en: 'Comfort', lv: 'Komforts', lt: 'Komfortas', pl: 'Komfort',
  },
  'features.comfort.desc': {
    ru: 'Спите, читайте, смотрите фильмы или следите, как меняется картинка за окном. Наши просторные сиденья с увеличенным местом для ног и кондиционер воздуха обеспечат вам приятную атмосферу на все время пути.',
    en: 'Sleep, read, watch movies or enjoy the view. Our spacious seats with extra legroom and air conditioning ensure a pleasant atmosphere throughout your journey.',
    lv: 'Guliet, lasiet, skatieties filmas vai sekojiet ainai aiz loga. Mūsu plašie sēdekļi ar palielinātu kāju telpu un gaisa kondicionēšana nodrošinās patīkamu atmosfēru visa ceļojuma laikā.',
    lt: 'Miegokite, skaitykite, žiūrėkite filmus ar stebėkite vaizdą pro langą. Mūsų erdvios sėdynės su padidinta kojų vieta ir oro kondicionavimas užtikrins malonią atmosferą visą kelionę.',
    pl: 'Śpij, czytaj, oglądaj filmy lub podziwiaj widoki za oknem. Nasze przestronne siedzenia z większą przestrzenią na nogi i klimatyzacja zapewnią przyjemną atmosferę przez całą podróż.',
  },
  'features.tv.title': {
    ru: 'Lux TV', en: 'Lux TV', lv: 'Lux TV', lt: 'Lux TV', pl: 'Lux TV',
  },
  'features.tv.desc': {
    ru: 'Индивидуальный мультимедийный экран делает поездку более приятной. Когда вам весело и интересно, время летит незаметно.',
    en: 'A personal multimedia screen makes the journey more enjoyable. When you\'re entertained, time flies by.',
    lv: 'Individuālais multimediju ekrāns padara braucienu patīkamāku. Kad ir interesanti, laiks paiet nemanot.',
    lt: 'Individualus multimedijos ekranas daro kelionę malonesnę. Kai smagu ir įdomu, laikas prabėga nepastebint.',
    pl: 'Indywidualny ekran multimedialny sprawia, że podróż jest przyjemniejsza. Gdy jest ciekawie, czas mija niezauważalnie.',
  },
  'features.internet.title': {
    ru: 'Интернет и 220V', en: 'Internet & 220V', lv: 'Internets un 220V', lt: 'Internetas ir 220V', pl: 'Internet i 220V',
  },
  'features.internet.desc': {
    ru: 'Бесплатный Wi-Fi и розетки рядом с каждым сиденьем помогают оставаться на связи в пути и дают свободу проводить время так, как вам хочется.',
    en: 'Free Wi-Fi and power outlets next to every seat help you stay connected on the go and give you freedom to spend your time however you like.',
    lv: 'Bezmaksas Wi-Fi un rozetes pie katra sēdekļa palīdz saglabāt sakarus ceļā un dod brīvību pavadīt laiku, kā vēlaties.',
    lt: 'Nemokamas Wi-Fi ir rozetės prie kiekvienos sėdynės padeda palaikyti ryšį kelyje ir suteikia laisvę leisti laiką taip, kaip norite.',
    pl: 'Darmowe Wi-Fi i gniazdka przy każdym miejscu pomagają pozostać w kontakcie w podróży i dają swobodę spędzania czasu tak, jak chcesz.',
  },
  // Amenity icons
  'amenity.ac': {
    ru: 'Кондиционер воздуха', en: 'Air conditioning', lv: 'Gaisa kondicionēšana', lt: 'Oro kondicionavimas', pl: 'Klimatyzacja',
  },
  'amenity.wifi': {
    ru: 'Бесплатный Wi-Fi', en: 'Free Wi-Fi', lv: 'Bezmaksas Wi-Fi', lt: 'Nemokamas Wi-Fi', pl: 'Darmowe Wi-Fi',
  },
  'amenity.eticket': {
    ru: 'Электронный билет', en: 'E-ticket', lv: 'E-biļete', lt: 'El. bilietas', pl: 'E-bilet',
  },
  'amenity.seatbelts': {
    ru: 'Ремни безопасности', en: 'Seatbelts', lv: 'Drošības jostas', lt: 'Saugos diržai', pl: 'Pasy bezpieczeństwa',
  },
  'amenity.wc': {
    ru: 'Туалет', en: 'Toilet', lv: 'Tualete', lt: 'Tualetas', pl: 'Toaleta',
  },

  // ===== Seat types =====
  'seats.title': {
    ru: 'Типы мест', en: 'Seat types', lv: 'Sēdvietu veidi', lt: 'Sėdynių tipai', pl: 'Typy miejsc',
  },
  'seats.desc': {
    ru: 'Выбирайте между стандартным комфортом Lux Express и повышенным комфортом Lux Lounge с увеличенным расстоянием между сиденьями и дополнительными удобствами.',
    en: 'Choose between standard Lux Express comfort and premium Lux Lounge comfort with extra legroom and additional amenities.',
    lv: 'Izvēlieties starp standarta Lux Express komfortu un paaugstinātu Lux Lounge komfortu ar palielinātu attālumu starp sēdekļiem.',
    lt: 'Rinkitės tarp standartinio Lux Express komforto ir padidinto Lux Lounge komforto su didesniu atstumu tarp sėdynių.',
    pl: 'Wybierz między standardowym komfortem Lux Express a podwyższonym komfortem Lux Lounge z większą odległością między siedzeniami.',
  },

  // ===== Tips =====
  'reviews.title': {
    ru: 'Отзывы пассажиров', en: 'Passenger reviews', lv: 'Pasažieru atsauksmes', lt: 'Keleivių atsiliepimai', pl: 'Opinie pasażerów',
  },
  'reviews.prev': {
    ru: 'НАЗАД', en: 'BACK', lv: 'ATPAKAĻ', lt: 'ATGAL', pl: 'WSTECZ',
  },
  'reviews.next': {
    ru: 'ВПЕРЕД', en: 'FORWARD', lv: 'TĀLĀK', lt: 'PIRMYN', pl: 'DALEJ',
  },
  'tips.title': {
    ru: 'Рекомендации путешественникам', en: 'Travel tips', lv: 'Ieteikumi ceļotājiem', lt: 'Patarimai keliautojams', pl: 'Porady dla podróżnych',
  },
  'tips.2': {
    ru: 'Прибывайте на автовокзал за 15 минут до отправления автобуса.',
    en: 'Arrive at the bus station 15 minutes before departure.',
    lv: 'Ierodieties autoostā 15 minūtes pirms autobusa atiešanas.',
    lt: 'Atvykite į autobusų stotį 15 minučių prieš išvykimą.',
    pl: 'Przyjedź na dworzec autobusowy 15 minut przed odjazdem.',
  },
  'tips.3': {
    ru: 'В каждом автобусе есть бесплатный Wi-Fi, розетки и USB-зарядки.',
    en: 'Every bus has free Wi-Fi, power outlets and USB charging.',
    lv: 'Katrā autobusā ir bezmaksas Wi-Fi, rozetes un USB uzlāde.',
    lt: 'Kiekviename autobuse yra nemokamas Wi-Fi, rozetės ir USB įkrovimas.',
    pl: 'Każdy autobus ma darmowe Wi-Fi, gniazdka i ładowanie USB.',
  },
  'tips.4': {
    ru: 'Вы можете перевозить до 2 единиц багажа бесплатно.',
    en: 'You can carry up to 2 pieces of luggage for free.',
    lv: 'Jūs varat pārvadāt līdz 2 bagāžas vienībām bez maksas.',
    lt: 'Galite vežti iki 2 bagažo vienetų nemokamai.',
    pl: 'Możesz zabrać do 2 sztuk bagażu za darmo.',
  },
  'tips.5': {
    ru: 'Билеты можно изменить или вернуть онлайн в личном кабинете.',
    en: 'Tickets can be changed or returned online in your account.',
    lv: 'Biļetes var mainīt vai atgriezt tiešsaistē savā kontā.',
    lt: 'Bilietus galima keisti arba grąžinti internetu savo paskyroje.',
    pl: 'Bilety można zmienić lub zwrócić online na swoim koncie.',
  },

  // ===== Search Results =====
  'results.selectOutbound': {
    ru: 'Выбрать рейс туда', en: 'Select outbound trip', lv: 'Izvēlieties reisu turp', lt: 'Pasirinkite reisą ten', pl: 'Wybierz przejazd tam',
  },
  'results.selectReturn': {
    ru: 'Выбрать рейс обратно', en: 'Select return trip', lv: 'Izvēlieties reisu atpakaļ', lt: 'Pasirinkite reisą atgal', pl: 'Wybierz przejazd powrotny',
  },
  'results.sortBy': {
    ru: 'Сортировать по', en: 'Sort by', lv: 'Kārtot pēc', lt: 'Rūšiuoti pagal', pl: 'Sortuj według',
  },
  'results.sortTime': {
    ru: 'Времени', en: 'Time', lv: 'Laiks', lt: 'Laikas', pl: 'Czas',
  },
  'results.sortPrice': {
    ru: 'Цене', en: 'Price', lv: 'Cena', lt: 'Kaina', pl: 'Cena',
  },
  'results.sortArrival': {
    ru: 'Прибытию', en: 'Arrival', lv: 'Ierašanās', lt: 'Atvykimas', pl: 'Przyjazd',
  },
  'results.changeSearch': {
    ru: 'Изменить поиск', en: 'Change search', lv: 'Mainīt meklēšanu', lt: 'Keisti paiešką', pl: 'Zmień wyszukiwanie',
  },
  'results.noTrips': {
    ru: 'Рейсы не найдены', en: 'No trips found', lv: 'Reisi nav atrasti', lt: 'Reisų nerasta', pl: 'Nie znaleziono przejazdów',
  },
  'results.tryOtherDate': {
    ru: 'Попробуйте выбрать другую дату', en: 'Try selecting another date', lv: 'Mēģiniet izvēlēties citu datumu', lt: 'Pabandykite pasirinkti kitą datą', pl: 'Spróbuj wybrać inną datę',
  },
  'results.driverThanks': {
    ru: 'Благодарность водителю', en: 'Thank the driver', lv: 'Pateicība šoferim', lt: 'Padėka vairuotojui', pl: 'Podziękowanie dla kierowcy',
  },
  'results.driverDesc': {
    ru: 'До 31 марта вы можете оценить поездку и оставить благодарность водителю, если вы остались довольны.',
    en: 'Until March 31, you can rate your trip and leave a thank you to the driver if you were satisfied.',
    lv: 'Līdz 31. martam varat novērtēt braucienu un atstāt pateicību šoferim, ja esat apmierināts.',
    lt: 'Iki kovo 31 d. galite įvertinti kelionę ir palikti padėką vairuotojui, jei buvote patenkinti.',
    pl: 'Do 31 marca możesz ocenić przejazd i zostawić podziękowanie dla kierowcy, jeśli byłeś zadowolony.',
  },

  // ===== Trip card =====
  'trip.direct': {
    ru: 'Прямой рейс', en: 'Direct', lv: 'Tiešais reiss', lt: 'Tiesioginis reisas', pl: 'Bezpośredni',
  },
  'trip.details': {
    ru: 'Подробнее', en: 'Details', lv: 'Vairāk', lt: 'Daugiau', pl: 'Więcej',
  },
  'trip.available': {
    ru: 'Места доступны', en: 'Seats available', lv: 'Vietas pieejamas', lt: 'Vietos prieinamos', pl: 'Miejsca dostępne',
  },
  'trip.seatsLeft': {
    ru: 'Осталось {n} мест', en: '{n} seats left', lv: 'Atlikušas {n} vietas', lt: 'Liko {n} vietų', pl: 'Zostało {n} miejsc',
  },
  'trip.business': {
    ru: 'БИЗНЕС', en: 'BUSINESS', lv: 'BIZNESS', lt: 'VERSLAS', pl: 'BIZNES',
  },
  'trip.recommended': {
    ru: 'РЕКОМЕНДУЕМ', en: 'RECOMMENDED', lv: 'IETEICAM', lt: 'REKOMENDUOJAME', pl: 'POLECAMY',
  },
  'trip.buy': {
    ru: 'КУПИ', en: 'BUY', lv: 'PIRKT', lt: 'PIRKTI', pl: 'KUP',
  },
  'trip.passenger': {
    ru: 'пассажир', en: 'passenger', lv: 'pasažieris', lt: 'keleivis', pl: 'pasażer',
  },
  'trip.passengers': {
    ru: 'пассажиры', en: 'passengers', lv: 'pasažieri', lt: 'keleiviai', pl: 'pasażerowie',
  },
  'trip.passengers2': {
    ru: 'пассажиры', en: 'passengers', lv: 'pasažieri', lt: 'keleiviai', pl: 'pasażerów',
  },
  'trip.passengers5': {
    ru: 'пассажиров', en: 'passengers', lv: 'pasažieru', lt: 'keleivių', pl: 'pasażerów',
  },
  'trip.hideDetails': {
    ru: 'Скрыть детали', en: 'Hide details', lv: 'Slēpt detaļas', lt: 'Slėpti detales', pl: 'Ukryj szczegóły',
  },
  'trip.busLounge': {
    ru: 'АВТОБУС LUX EXPRESS LOUNGE', en: 'BUS LUX EXPRESS LOUNGE', lv: 'AUTOBUSS LUX EXPRESS LOUNGE', lt: 'AUTOBUSAS LUX EXPRESS LOUNGE', pl: 'AUTOBUS LUX EXPRESS LOUNGE',
  },
  'trip.busExpress': {
    ru: 'LUX EXPRESS', en: 'LUX EXPRESS', lv: 'LUX EXPRESS', lt: 'LUX EXPRESS', pl: 'LUX EXPRESS',
  },
  'trip.directTrips': {
    ru: 'Прямой рейс', en: 'Direct trip', lv: 'Tiešais reiss', lt: 'Tiesioginis reisas', pl: 'Bezpośredni',
  },

  // ===== Destination page =====
  'dest.notFound': {
    ru: 'Город не найден', en: 'City not found', lv: 'Pilsēta nav atrasta', lt: 'Miestas nerastas', pl: 'Miasto nie znalezione',
  },
  'dest.goHome': {
    ru: 'На главную', en: 'Go to homepage', lv: 'Uz sākumlapu', lt: 'Į pradžią', pl: 'Na stronę główną',
  },
  'dest.popularRoutes': {
    ru: 'Популярные направления', en: 'Popular routes', lv: 'Populāri maršruti', lt: 'Populiarūs maršrutai', pl: 'Popularne trasy',
  },

  // ===== Step indicator =====
  'step.1': {
    ru: 'Поиск', en: 'Search', lv: 'Meklēšana', lt: 'Paieška', pl: 'Wyszukiwanie',
  },
  'step.2': {
    ru: 'Выбор места', en: 'Seat selection', lv: 'Vietas izvēle', lt: 'Vietos pasirinkimas', pl: 'Wybór miejsca',
  },
  'step.3': {
    ru: 'Данные пассажира', en: 'Passenger details', lv: 'Pasažieru dati', lt: 'Keleivio duomenys', pl: 'Dane pasażera',
  },
  'step.4': {
    ru: 'Дополнительные услуги', en: 'Additional services', lv: 'Papildu pakalpojumi', lt: 'Papildomos paslaugos', pl: 'Dodatkowe usługi',
  },
  'step.5': {
    ru: 'Детали платежа', en: 'Payment details', lv: 'Maksājuma dati', lt: 'Mokėjimo duomenys', pl: 'Szczegóły płatności',
  },

  // ===== Passenger page =====
  'passenger.title': {
    ru: 'Данные пассажира', en: 'Passenger details', lv: 'Pasažieru dati', lt: 'Keleivio duomenys', pl: 'Dane pasażera',
  },
  'passenger.label': {
    ru: 'Пассажир 1 — Взрослый', en: 'Passenger 1 — Adult', lv: 'Pasažieris 1 — Pieaugušais', lt: 'Keleivis 1 — Suaugęs', pl: 'Pasażer 1 — Dorosły',
  },
  'passenger.firstName': {
    ru: 'Имя', en: 'First name', lv: 'Vārds', lt: 'Vardas', pl: 'Imię',
  },
  'passenger.lastName': {
    ru: 'Фамилия', en: 'Last name', lv: 'Uzvārds', lt: 'Pavardė', pl: 'Nazwisko',
  },
  'passenger.email': {
    ru: 'E-mail', en: 'E-mail', lv: 'E-pasts', lt: 'El. paštas', pl: 'E-mail',
  },
  'passenger.phone': {
    ru: 'Телефон', en: 'Phone', lv: 'Tālrunis', lt: 'Telefonas', pl: 'Telefon',
  },
  'passenger.phonePlaceholder': {
    ru: 'Номер телефона', en: 'Phone number', lv: 'Tālruņa numurs', lt: 'Telefono numeris', pl: 'Numer telefonu',
  },
  'passenger.firstNamePlaceholder': {
    ru: 'Введите имя', en: 'Enter first name', lv: 'Ievadiet vārdu', lt: 'Įveskite vardą', pl: 'Wpisz imię',
  },
  'passenger.lastNamePlaceholder': {
    ru: 'Введите фамилию', en: 'Enter last name', lv: 'Ievadiet uzvārdu', lt: 'Įveskite pavardę', pl: 'Wpisz nazwisko',
  },
  'passenger.backToTrips': {
    ru: '← Назад к рейсам', en: '← Back to trips', lv: '← Atpakaļ pie reisiem', lt: '← Grįžti prie reisų', pl: '← Powrót do przejazdów',
  },
  'passenger.toPayment': {
    ru: 'Перейти к оплате', en: 'Proceed to payment', lv: 'Pāriet uz apmaksu', lt: 'Pereiti prie mokėjimo', pl: 'Przejdź do płatności',
  },

  // ===== Trip summary =====
  'summary.title': {
    ru: 'Детали поездки', en: 'Trip details', lv: 'Brauciena detaļas', lt: 'Kelionės informacija', pl: 'Szczegóły przejazdu',
  },
  'summary.outbound': {
    ru: 'Поездка туда', en: 'Outbound trip', lv: 'Brauciens turp', lt: 'Kelionė ten', pl: 'Przejazd tam',
  },
  'summary.return': {
    ru: 'Поездка обратно', en: 'Return trip', lv: 'Brauciens atpakaļ', lt: 'Kelionė atgal', pl: 'Przejazd powrotny',
  },
  'summary.passenger': {
    ru: 'Пассажир', en: 'Passenger', lv: 'Pasažieris', lt: 'Keleivis', pl: 'Pasażer',
  },
  'summary.total': {
    ru: 'Итоговая сумма', en: 'Total', lv: 'Kopā', lt: 'Iš viso', pl: 'Suma',
  },

  // ===== Payment page =====
  'payment.title': {
    ru: 'Детали платежа', en: 'Payment details', lv: 'Maksājuma dati', lt: 'Mokėjimo duomenys', pl: 'Szczegóły płatności',
  },
  'payment.banks': {
    ru: 'Банки', en: 'Banks', lv: 'Bankas', lt: 'Bankai', pl: 'Banki',
  },
  'payment.card': {
    ru: 'Кредитная карта', en: 'Credit card', lv: 'Kredītkarte', lt: 'Kreditinė kortelė', pl: 'Karta kredytowa',
  },
  'payment.business': {
    ru: 'Бизнес-клиент', en: 'Business client', lv: 'Biznesa klients', lt: 'Verslo klientas', pl: 'Klient biznesowy',
  },
  'payment.cardLabel': {
    ru: 'Кредитная или дебетовая карта', en: 'Credit or debit card', lv: 'Kredītkarte vai debetkarte', lt: 'Kreditinė arba debetinė kortelė', pl: 'Karta kredytowa lub debetowa',
  },
  'payment.cardNumber': {
    ru: 'Номер карты', en: 'Card number', lv: 'Kartes numurs', lt: 'Kortelės numeris', pl: 'Numer karty',
  },
  'payment.expiry': {
    ru: 'Срок действия', en: 'Expiry date', lv: 'Derīguma termiņš', lt: 'Galiojimo data', pl: 'Data ważności',
  },
  'payment.cvv': {
    ru: 'Защитный код', en: 'Security code', lv: 'Drošības kods', lt: 'Saugumo kodas', pl: 'Kod bezpieczeństwa',
  },
  'payment.cvvPlaceholder': {
    ru: '3 цифры', en: '3 digits', lv: '3 cipari', lt: '3 skaitmenys', pl: '3 cyfry',
  },
  'payment.cardName': {
    ru: 'Имя на карте', en: 'Name on card', lv: 'Vārds uz kartes', lt: 'Vardas ant kortelės', pl: 'Imię na karcie',
  },
  'payment.cardNamePlaceholder': {
    ru: 'Введите имя владельца карты', en: 'Enter cardholder name', lv: 'Ievadiet kartes īpašnieka vārdu', lt: 'Įveskite kortelės savininko vardą', pl: 'Wprowadź imię posiadacza karty',
  },
  'payment.pay': {
    ru: 'Заплатить', en: 'Pay', lv: 'Maksāt', lt: 'Mokėti', pl: 'Zapłać',
  },
  'payment.processing': {
    ru: 'Обработка...', en: 'Processing...', lv: 'Apstrāde...', lt: 'Apdorojimas...', pl: 'Przetwarzanie...',
  },
  'payment.minutes': {
    ru: 'минут', en: 'min', lv: 'min', lt: 'min', pl: 'min',
  },
  'payment.seconds': {
    ru: 'секунд', en: 'sec', lv: 'sek', lt: 'sek', pl: 'sek',
  },
  'payment.addVoucher': {
    ru: '+ Добавить ваучер', en: '+ Add voucher', lv: '+ Pievienot vaučeru', lt: '+ Pridėti vaučerį', pl: '+ Dodaj voucher',
  },
  'payment.terms': {
    ru: 'Завершая это бронирование, я соглашаюсь с условиями продажи билетов Lux Express.',
    en: 'By completing this booking, I agree to the Lux Express ticket sales terms.',
    lv: 'Pabeidzot šo rezervāciju, es piekrītu Lux Express biļešu pārdošanas noteikumiem.',
    lt: 'Užbaigdamas šį užsakymą, sutinku su Lux Express bilietų pardavimo sąlygomis.',
    pl: 'Kończąc tę rezerwację, zgadzam się z warunkami sprzedaży biletów Lux Express.',
  },
  'payment.corpDiscount': {
    ru: 'Корпоративные скидки, доступные по вашему договору, будут автоматически применены и отображены в вашем счете.',
    en: 'Corporate discounts available under your agreement will be automatically applied and shown on your invoice.',
    lv: 'Korporatīvās atlaides, kas pieejamas saskaņā ar jūsu līgumu, tiks automātiski piemērotas un parādītas jūsu rēķinā.',
    lt: 'Korporatyvinės nuolaidos pagal jūsų sutartį bus automatiškai pritaikytos ir parodytos jūsų sąskaitoje.',
    pl: 'Rabaty korporacyjne dostępne na podstawie umowy zostaną automatycznie zastosowane i wyświetlone na fakturze.',
  },
  'payment.selectBank': {
    ru: 'Выберите ваш банк для оплаты', en: 'Select your bank for payment', lv: 'Izvēlieties savu banku maksājumam', lt: 'Pasirinkite savo banką mokėjimui', pl: 'Wybierz swój bank do płatności',
  },
  'payment.businessLogin': {
    ru: 'Войдите в бизнес-аккаунт для оплаты по счёту',
    en: 'Log in to your business account for invoice payment',
    lv: 'Piesakieties biznesa kontā, lai maksātu ar rēķinu',
    lt: 'Prisijunkite prie verslo paskyros mokėjimui sąskaita',
    pl: 'Zaloguj się do konta biznesowego, aby zapłacić fakturą',
  },
  'payment.loginBtn': {
    ru: 'Войти', en: 'Log in', lv: 'Ieiet', lt: 'Prisijungti', pl: 'Zaloguj się',
  },

  // ===== Success =====
  'success.title': {
    ru: 'Оплата прошла успешно!', en: 'Payment successful!', lv: 'Maksājums veiksmīgs!', lt: 'Mokėjimas sėkmingas!', pl: 'Płatność zakończona pomyślnie!',
  },
  'success.ticketSent': {
    ru: 'Билет отправлен на', en: 'Ticket sent to', lv: 'Biļete nosūtīta uz', lt: 'Bilietas išsiųstas į', pl: 'Bilet wysłany na',
  },
  'success.route': {
    ru: 'Маршрут', en: 'Route', lv: 'Maršruts', lt: 'Maršrutas', pl: 'Trasa',
  },
  'success.date': {
    ru: 'Дата', en: 'Date', lv: 'Datums', lt: 'Data', pl: 'Data',
  },
  'success.time': {
    ru: 'Время', en: 'Time', lv: 'Laiks', lt: 'Laikas', pl: 'Czas',
  },
  'success.passenger': {
    ru: 'Пассажир', en: 'Passenger', lv: 'Pasažieris', lt: 'Keleivis', pl: 'Pasażer',
  },
  'success.totalLabel': {
    ru: 'Итого', en: 'Total', lv: 'Kopā', lt: 'Iš viso', pl: 'Suma',
  },
  'success.backHome': {
    ru: 'На главную', en: 'Go to homepage', lv: 'Uz sākumu', lt: 'Į pagrindinį', pl: 'Na stronę główną',
  },

  // ===== Footer =====
  'footer.info': {
    ru: 'Информация', en: 'Information', lv: 'Informācija', lt: 'Informacija', pl: 'Informacja',
  },
  'footer.faq': {
    ru: 'Часто задаваемые вопросы', en: 'FAQ', lv: 'Biežāk uzdotie jautājumi', lt: 'DUK', pl: 'FAQ',
  },
  'footer.routes': {
    ru: 'Маршруты', en: 'Routes', lv: 'Maršruti', lt: 'Maršrutai', pl: 'Trasy',
  },
  'footer.contacts': {
    ru: 'Контакты', en: 'Contacts', lv: 'Kontakti', lt: 'Kontaktai', pl: 'Kontakt',
  },
  'footer.about': {
    ru: 'О нас', en: 'About us', lv: 'Par mums', lt: 'Apie mus', pl: 'O nas',
  },
  'footer.career': {
    ru: 'Карьера', en: 'Career', lv: 'Karjera', lt: 'Karjera', pl: 'Kariera',
  },
  'footer.businessService': {
    ru: 'Бизнес-сервис', en: 'Business service', lv: 'Biznesa serviss', lt: 'Verslo paslauga', pl: 'Usługa biznesowa',
  },
  'footer.docs': {
    ru: 'Документы', en: 'Documents', lv: 'Dokumenti', lt: 'Dokumentai', pl: 'Dokumenty',
  },
  'footer.privacy': {
    ru: 'Политика конфиденциальности', en: 'Privacy policy', lv: 'Konfidencialitātes politika', lt: 'Privatumo politika', pl: 'Polityka prywatności',
  },
  'footer.salesTerms': {
    ru: 'Правила продажи билетов', en: 'Ticket sales terms', lv: 'Biļešu pārdošanas noteikumi', lt: 'Bilietų pardavimo taisyklės', pl: 'Regulamin sprzedaży biletów',
  },
  'footer.customs': {
    ru: 'Таможенная служба', en: 'Customs service', lv: 'Muitas dienests', lt: 'Muitinės tarnyba', pl: 'Służba celna',
  },
  'footer.transportRules': {
    ru: 'Правила перевозки', en: 'Transport rules', lv: 'Pārvadāšanas noteikumi', lt: 'Vežimo taisyklės', pl: 'Zasady przewozu',
  },
  'footer.follow': {
    ru: 'Следите за нами', en: 'Follow us', lv: 'Sekojiet mums', lt: 'Sekite mus', pl: 'Obserwuj nas',
  },
  'footer.subscribe': {
    ru: 'Подпишитесь на рассылку', en: 'Subscribe to newsletter', lv: 'Pierakstieties jaunumiem', lt: 'Prenumeruokite naujienlaiškį', pl: 'Zapisz się do newslettera',
  },
  'footer.emailPlaceholder': {
    ru: 'E-почта', en: 'E-mail', lv: 'E-pasts', lt: 'El. paštas', pl: 'E-mail',
  },
  'footer.join': {
    ru: 'Присоединиться', en: 'Join', lv: 'Pievienoties', lt: 'Prisijungti', pl: 'Dołącz',
  },

  // ===== Passenger categories =====
  'cat.adult': {
    ru: 'Взрослый', en: 'Adult', lv: 'Pieaugušais', lt: 'Suaugęs', pl: 'Dorosły',
  },
  'cat.adultAge': {
    ru: 'Standard', en: 'Standard', lv: 'Standarta', lt: 'Standartinis', pl: 'Standardowy',
  },
  'cat.senior': {
    ru: 'Пожилые', en: 'Senior', lv: 'Seniori', lt: 'Senjorai', pl: 'Seniorzy',
  },
  'cat.seniorAge': {
    ru: 'Старше 60 лет (вкл.), в среднем до ~10%', en: '60+ years (incl.), avg. discount ~10%', lv: 'Virs 60 gadiem (ieskaitot), atlaide ~10%', lt: 'Virš 60 metų (įsk.), nuolaida ~10%', pl: 'Powyżej 60 lat (włącznie), zniżka ~10%',
  },
  'cat.youth': {
    ru: 'Молодые', en: 'Youth', lv: 'Jaunieši', lt: 'Jaunimas', pl: 'Młodzież',
  },
  'cat.youthAge': {
    ru: 'Молодежь до 26 лет (включительно), в среднем до ~10%', en: 'Up to 26 years (incl.), avg. discount ~10%', lv: 'Līdz 26 gadiem (ieskaitot), atlaide ~10%', lt: 'Iki 26 metų (įsk.), nuolaida ~10%', pl: 'Do 26 lat (włącznie), zniżka ~10%',
  },
  'cat.child': {
    ru: 'Дети', en: 'Children', lv: 'Bērni', lt: 'Vaikai', pl: 'Dzieci',
  },
  'cat.childAge': {
    ru: 'Ребенок до 16 лет (вкл.), в среднем до ~40%', en: 'Up to 16 years (incl.), avg. discount ~40%', lv: 'Līdz 16 gadiem (ieskaitot), atlaide ~40%', lt: 'Iki 16 metų (įsk.), nuolaida ~40%', pl: 'Do 16 lat (włącznie), zniżka ~40%',
  },
  'cat.preschool': {
    ru: 'Дошкольники', en: 'Preschool', lv: 'Pirmsskolas', lt: 'Ikimokyklinukai', pl: 'Przedszkolaki',
  },
  'cat.preschoolAge': {
    ru: 'Дошкольники до 7 лет (вкл.) ~60%', en: 'Up to 7 years (incl.) ~60%', lv: 'Līdz 7 gadiem (ieskaitot) ~60%', lt: 'Iki 7 metų (įsk.) ~60%', pl: 'Do 7 lat (włącznie) ~60%',
  },

  // ===== Seat Selection Page =====
  'seat.title': {
    ru: 'Выбор места', en: 'Seat selection', lv: 'Vietas izvēle', lt: 'Vietos pasirinkimas', pl: 'Wybór miejsca',
  },
  'seat.standard': {
    ru: 'Standard', en: 'Standard', lv: 'Standarta', lt: 'Standartinė', pl: 'Standardowe',
  },
  'seat.relax': {
    ru: 'Relax', en: 'Relax', lv: 'Relax', lt: 'Relax', pl: 'Relax',
  },
  'seat.selected': {
    ru: 'Выбрано', en: 'Selected', lv: 'Izvēlēts', lt: 'Pasirinkta', pl: 'Wybrane',
  },
  'seat.occupied': {
    ru: 'Занято', en: 'Occupied', lv: 'Aizņemts', lt: 'Užimta', pl: 'Zajęte',
  },
  'seat.passenger': {
    ru: 'Пассажир', en: 'Passenger', lv: 'Pasažieris', lt: 'Keleivis', pl: 'Pasażer',
  },
  'seat.seatLabel': {
    ru: 'МЕСТО', en: 'SEAT', lv: 'VIETA', lt: 'VIETA', pl: 'MIEJSCE',
  },
  'seat.ticketType': {
    ru: 'Тип билета', en: 'Ticket type', lv: 'Biļetes veids', lt: 'Bilieto tipas', pl: 'Typ biletu',
  },
  'seat.promoTicket': {
    ru: 'Билет по акции', en: 'Promo ticket', lv: 'Akcijas biļete', lt: 'Akcijos bilietas', pl: 'Bilet promocyjny',
  },
  'seat.promoNonRefund': {
    ru: 'Не подлежит возврату', en: 'Non-refundable', lv: 'Nav atgriežams', lt: 'Negrąžinamas', pl: 'Bezzwrotny',
  },
  'seat.promoNote': {
    ru: 'Акционные билеты возврату не подлежат. Скидки не распространяются на кресла Relax', en: 'Promo tickets are non-refundable. Discounts do not apply to Relax seats', lv: 'Akcijas biļetes nav atgriežamas. Atlaides neattiecas uz Relax krēsliem', lt: 'Akcijų bilietai negrąžinami. Nuolaidos netaikomos Relax sėdynėms', pl: 'Bilety promocyjne nie podlegają zwrotowi. Zniżki nie dotyczą foteli Relax',
  },
  'seat.continue': {
    ru: 'ПРОДОЛЖИТЬ', en: 'CONTINUE', lv: 'TURPINĀT', lt: 'TĘSTI', pl: 'KONTYNUUJ',
  },
  'seat.selectSeat': {
    ru: 'Выберите место', en: 'Select a seat', lv: 'Izvēlieties vietu', lt: 'Pasirinkite vietą', pl: 'Wybierz miejsce',
  },
  'seat.clickToSelect': {
    ru: 'Нажмите на пассажира, затем на место', en: 'Click on a passenger, then on a seat', lv: 'Noklikšķiniet uz pasažiera, tad uz vietas', lt: 'Spustelėkite keleivį, tada vietą', pl: 'Kliknij na pasażera, potem na miejsce',
  },
  'seat.tripDetails': {
    ru: 'Детали поездки', en: 'Trip details', lv: 'Brauciena detaļas', lt: 'Kelionės informacija', pl: 'Szczegóły przejazdu',
  },
  'seat.outboundTrip': {
    ru: 'Поездка туда', en: 'Outbound trip', lv: 'Brauciens turp', lt: 'Kelionė ten', pl: 'Przejazd tam',
  },
  'seat.totalAmount': {
    ru: 'Итоговая сумма', en: 'Total', lv: 'Kopā', lt: 'Iš viso', pl: 'Suma',
  },
  'search.addPassenger': {
    ru: 'пасс.', en: 'pass.', lv: 'pas.', lt: 'kel.', pl: 'pas.',
  },
  'search.promoCode': {
    ru: 'Промокод', en: 'Promo code', lv: 'Promo kods', lt: 'Promo kodas', pl: 'Kod promocyjny',
  },
  'search.enterCode': {
    ru: 'Ввести код', en: 'Enter code', lv: 'Ievadiet kodu', lt: 'Įveskite kodą', pl: 'Wpisz kod',
  },

  // ===== Home page extra =====
  'home.luxLoungeSeat': {
    ru: 'Кресло Lux Lounge', en: 'Lux Lounge seat', lv: 'Lux Lounge sēdeklis', lt: 'Lux Lounge sėdynė', pl: 'Fotel Lux Lounge',
  },
  'home.luxExpressSeat': {
    ru: 'Кресло Lux Express', en: 'Lux Express seat', lv: 'Lux Express sēdeklis', lt: 'Lux Express sėdynė', pl: 'Fotel Lux Express',
  },
  'home.busStation': {
    ru: 'Автовокзал', en: 'Bus station', lv: 'Autoosta', lt: 'Autobusų stotis', pl: 'Dworzec autobusowy',
  },

  // ===== Payment page extra =====
  'payment.orPayWith': {
    ru: 'Или оплатите через', en: 'Or pay with', lv: 'Vai maksājiet ar', lt: 'Arba mokėkite su', pl: 'Lub zapłać przez',
  },
  'payment.timeLeft': {
    ru: 'Осталось времени для оплаты', en: 'Time left to pay', lv: 'Atlikušais laiks maksājumam', lt: 'Liko laiko mokėjimui', pl: 'Pozostały czas na płatność',
  },
  'payment.bookingRef': {
    ru: 'Номер бронирования', en: 'Booking reference', lv: 'Rezervācijas numurs', lt: 'Užsakymo numeris', pl: 'Numer rezerwacji',
  },

  // ===== Footer extra =====
  'footer.copyright': {
    ru: '© 2026 Lux Express', en: '© 2026 Lux Express', lv: '© 2026 Lux Express', lt: '© 2026 Lux Express', pl: '© 2026 Lux Express',
  },
  'footer.downloadAppStore': {
    ru: 'Загрузить в', en: 'Download on', lv: 'Lejupielādēt', lt: 'Atsisiųsti iš', pl: 'Pobierz z',
  },
  'footer.getGooglePlay': {
    ru: 'Доступно в', en: 'Get it on', lv: 'Pieejams', lt: 'Gauti iš', pl: 'Pobierz z',
  },

  // ===== Passenger details back button =====
  'passenger.backToSeats': {
    ru: '← Назад к выбору мест', en: '← Back to seat selection', lv: '← Atpakaļ pie vietu izvēles', lt: '← Grįžti prie vietų pasirinkimo', pl: '← Powrót do wyboru miejsc',
  },

  // ===== Auth =====
  'auth.login': { ru: 'Вход', en: 'Log in', lv: 'Ieiet', lt: 'Prisijungti', pl: 'Logowanie' },
  'auth.register': { ru: 'Регистрация', en: 'Register', lv: 'Reģistrēties', lt: 'Registruotis', pl: 'Rejestracja' },
  'auth.email': { ru: 'E-mail', en: 'E-mail', lv: 'E-pasts', lt: 'El. paštas', pl: 'E-mail' },
  'auth.password': { ru: 'Пароль', en: 'Password', lv: 'Parole', lt: 'Slaptažodis', pl: 'Hasło' },
  'auth.confirmPassword': { ru: 'Подтвердите пароль', en: 'Confirm password', lv: 'Apstiprināt paroli', lt: 'Patvirtinti slaptažodį', pl: 'Potwierdź hasło' },
  'auth.loginBtn': { ru: 'Авторизация', en: 'Log in', lv: 'Ieiet', lt: 'Prisijungti', pl: 'Zaloguj się' },
  'auth.registerBtn': { ru: 'Зарегистрироваться', en: 'Create account', lv: 'Izveidot kontu', lt: 'Sukurti paskyrą', pl: 'Utwórz konto' },
  'auth.noAccount': { ru: 'Нет аккаунта?', en: 'No account?', lv: 'Nav konta?', lt: 'Neturite paskyros?', pl: 'Nie masz konta?' },
  'auth.hasAccount': { ru: 'Уже есть аккаунт?', en: 'Already have an account?', lv: 'Jau ir konts?', lt: 'Jau turite paskyrą?', pl: 'Masz konto?' },
  'auth.wrongCredentials': { ru: 'Неверный email или пароль', en: 'Wrong email or password', lv: 'Nepareizs e-pasts vai parole', lt: 'Neteisingas el. paštas arba slaptažodis', pl: 'Nieprawidłowy e-mail lub hasło' },
  'auth.passwordMismatch': { ru: 'Пароли не совпадают', en: 'Passwords do not match', lv: 'Paroles nesakrīt', lt: 'Slaptažodžiai nesutampa', pl: 'Hasła nie pasują' },
  'auth.emailExists': { ru: 'Этот email уже зарегистрирован', en: 'This email is already registered', lv: 'Šis e-pasts jau ir reģistrēts', lt: 'Šis el. paštas jau registruotas', pl: 'Ten e-mail jest już zarejestrowany' },
  'auth.logout': { ru: 'Выйти', en: 'Log out', lv: 'Iziet', lt: 'Atsijungti', pl: 'Wyloguj się' },

  // ===== Account =====
  'account.myAccount': { ru: 'Мой аккаунт', en: 'My account', lv: 'Mans konts', lt: 'Mano paskyra', pl: 'Moje konto' },
  'account.loyalty': { ru: 'Программа лояльности', en: 'Loyalty program', lv: 'Lojalitātes programma', lt: 'Lojalumo programa', pl: 'Program lojalnościowy' },
  'account.trips': { ru: 'Поездки', en: 'Trips', lv: 'Braucieni', lt: 'Kelionės', pl: 'Podróże' },
  'account.profile': { ru: 'Персональные данные', en: 'Personal data', lv: 'Personīgie dati', lt: 'Asmeniniai duomenys', pl: 'Dane osobowe' },
  'account.security': { ru: 'Безопасность', en: 'Security', lv: 'Drošība', lt: 'Saugumas', pl: 'Bezpieczeństwo' },
  'account.settings': { ru: 'Настройки', en: 'Settings', lv: 'Iestatījumi', lt: 'Nustatymai', pl: 'Ustawienia' },
  'account.tripsCount': { ru: 'Накопленные поездки', en: 'Accumulated trips', lv: 'Uzkrātie braucieni', lt: 'Sukauptos kelionės', pl: 'Zebrane podróże' },
  'account.tripsNeeded': { ru: 'Поездки, которые осталось совершить', en: 'Trips remaining', lv: 'Atlikušie braucieni', lt: 'Likusios kelionės', pl: 'Pozostałe podróże' },
  'account.upcoming': { ru: 'Предстоящие', en: 'Upcoming', lv: 'Gaidāmie', lt: 'Būsimos', pl: 'Nadchodzące' },
  'account.past': { ru: 'Прошедшие', en: 'Past', lv: 'Pagājušie', lt: 'Praėjusios', pl: 'Przeszłe' },
  'account.noTickets': { ru: 'Билеты не найдены', en: 'No tickets found', lv: 'Biļetes nav atrastas', lt: 'Bilietų nerasta', pl: 'Nie znaleziono biletów' },
  'account.noTicketsDesc': { ru: 'Купленные вами билеты будут отображаться здесь', en: 'Your purchased tickets will appear here', lv: 'Jūsu iegādātās biļetes parādīsies šeit', lt: 'Jūsų įsigyti bilietai bus rodomi čia', pl: 'Kupione bilety pojawią się tutaj' },
  'account.searchTrips': { ru: 'ПОИСК БИЛЕТОВ', en: 'SEARCH TICKETS', lv: 'MEKLĒT BIĻETES', lt: 'IEŠKOTI BILIETŲ', pl: 'SZUKAJ BILETÓW' },
  'account.save': { ru: 'Сохранить', en: 'Save', lv: 'Saglabāt', lt: 'Išsaugoti', pl: 'Zapisz' },
  'account.saved': { ru: 'Сохранено', en: 'Saved', lv: 'Saglabāts', lt: 'Išsaugota', pl: 'Zapisano' },
  'account.male': { ru: 'Мужчина', en: 'Male', lv: 'Vīrietis', lt: 'Vyras', pl: 'Mężczyzna' },
  'account.female': { ru: 'Женщина', en: 'Female', lv: 'Sieviete', lt: 'Moteris', pl: 'Kobieta' },
  'account.myTrips': { ru: 'Мои поездки', en: 'My trips', lv: 'Mani braucieni', lt: 'Mano kelionės', pl: 'Moje podróże' },
  'account.changePassword': { ru: 'Сменить пароль', en: 'Change password', lv: 'Mainīt paroli', lt: 'Keisti slaptažodį', pl: 'Zmień hasło' },
  'account.currentPassword': { ru: 'Текущий пароль', en: 'Current password', lv: 'Pašreizējā parole', lt: 'Dabartinis slaptažodis', pl: 'Obecne hasło' },
  'account.newPassword': { ru: 'Новый пароль', en: 'New password', lv: 'Jaunā parole', lt: 'Naujas slaptažodis', pl: 'Nowe hasło' },
  'account.passwordChanged': { ru: 'Пароль изменён', en: 'Password changed', lv: 'Parole mainīta', lt: 'Slaptažodis pakeistas', pl: 'Hasło zmienione' },
  'account.year': { ru: 'В течение года (за последние 365 дней)', en: 'Within the year (last 365 days)', lv: 'Gada laikā (pēdējās 365 dienas)', lt: 'Per metus (paskutines 365 dienas)', pl: 'W ciągu roku (ostatnie 365 dni)' },
  'account.forFreeTicket': { ru: 'Для получения бесплатного билета (по состоянию на вчерашний день)', en: 'For a free ticket (as of yesterday)', lv: 'Bezmaksas biļetei (uz vakardienu)', lt: 'Nemokamam bilietui (vakar)', pl: 'Na darmowy bilet (stan na wczoraj)' },
  'account.paymentMethods': { ru: 'Способы оплаты', en: 'Payment methods', lv: 'Maksājumu veidi', lt: 'Mokėjimo būdai', pl: 'Metody płatności' },
  'account.vouchers': { ru: 'Ваучеры', en: 'Vouchers', lv: 'Vaučeri', lt: 'Vaučeriai', pl: 'Vouchery' },
  'account.noPaymentMethods': { ru: 'Способы оплаты не добавлены', en: 'No payment methods added', lv: 'Nav pievienotu maksājumu veidu', lt: 'Mokėjimo būdų nepridėta', pl: 'Nie dodano metod płatności' },
  'account.noPaymentMethodsDesc': { ru: 'Добавьте банковскую карту для быстрой оплаты билетов', en: 'Add a bank card for fast ticket payment', lv: 'Pievienojiet bankas karti ātrai biļešu apmaksai', lt: 'Pridėkite banko kortelę greitam bilietų apmokėjimui', pl: 'Dodaj kartę bankową do szybkiej płatności za bilety' },
  'account.addCard': { ru: 'Добавить карту', en: 'Add card', lv: 'Pievienot karti', lt: 'Pridėti kortelę', pl: 'Dodaj kartę' },
  'account.noVouchers': { ru: 'Ваучеры не найдены', en: 'No vouchers found', lv: 'Vaučeri nav atrasti', lt: 'Vaučerių nerasta', pl: 'Nie znaleziono voucherów' },
  'account.noVouchersDesc': { ru: 'Ваши ваучеры будут отображаться здесь', en: 'Your vouchers will appear here', lv: 'Jūsu vaučeri parādīsies šeit', lt: 'Jūsų vaučeriai bus rodomi čia', pl: 'Twoje vouchery pojawią się tutaj' },
  'account.enterVoucher': { ru: 'Введите код ваучера', en: 'Enter voucher code', lv: 'Ievadiet vaučera kodu', lt: 'Įveskite vaučerio kodą', pl: 'Wprowadź kod vouchera' },
  'account.activate': { ru: 'Активировать', en: 'Activate', lv: 'Aktivizēt', lt: 'Aktyvuoti', pl: 'Aktywuj' },
  'account.language': { ru: 'Язык', en: 'Language', lv: 'Valoda', lt: 'Kalba', pl: 'Język' },
  'account.currency': { ru: 'Валюта', en: 'Currency', lv: 'Valūta', lt: 'Valiuta', pl: 'Waluta' },
  'account.notifications': { ru: 'Уведомления по email', en: 'Email notifications', lv: 'E-pasta paziņojumi', lt: 'El. pašto pranešimai', pl: 'Powiadomienia e-mail' },
  'account.newsletter': { ru: 'Подписка на новости', en: 'Newsletter subscription', lv: 'Jaunumu abonēšana', lt: 'Naujienlaiškio prenumerata', pl: 'Subskrypcja newslettera' },
  'account.loyaltyInfo1': { ru: 'Для получения статуса Frequent Traveler необходимо совершить как минимум 30 поездок за последний год (365 дней). Статус frequent traveler действует ещё 6 месяцев после того, как количество статусных поездок, совершенных за последний год, станет меньше 30.', en: 'To obtain Frequent Traveler status, you must complete at least 30 trips in the last year (365 days). Frequent traveler status remains active for 6 months after the number of qualifying trips falls below 30.', lv: 'Lai iegūtu Frequent Traveler statusu, pēdējā gadā (365 dienās) jāveic vismaz 30 braucieni.', lt: 'Norint gauti Frequent Traveler statusą, per pastaruosius metus (365 dienas) reikia atlikti mažiausiai 30 kelionių.', pl: 'Aby uzyskać status Frequent Traveler, należy odbyć co najmniej 30 podróży w ostatnim roku (365 dni).' },
  'account.loyaltyInfo2': { ru: 'Бесплатные билеты и билеты эконом-класса, купленные в рамках специальных предложений по кампании (акционные билеты) не учитываются.', en: 'Free tickets and economy class tickets purchased under special campaign offers (promotional tickets) are not counted.', lv: 'Bezmaksas biļetes un ekonomiskās klases biļetes, kas iegādātas īpašo piedāvājumu ietvaros, netiek ieskaitītas.', lt: 'Nemokami bilietai ir ekonominės klasės bilietai, įsigyti pagal specialius pasiūlymus, neskaičiuojami.', pl: 'Bilety bezpłatne i bilety klasy ekonomicznej zakupione w ramach ofert specjalnych nie są liczone.' },
  'account.deleteAccount': { ru: 'Удалить аккаунт', en: 'Delete account', lv: 'Dzēst kontu', lt: 'Ištrinti paskyrą', pl: 'Usuń konto' },
};

export default translations;
